import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Info } from "../Info";
import { testLocator } from "../../lib/helpers/test-locator";
import { Text } from "../Text";
import { TextColors, TextTypes } from "../constants";

import "./styles.scss";

export const FormField = ({
  children,
  className,
  errorMessage,
  errorTestId,
  errorTestLocatorId,
  label,
  labelClassName,
  sublabel,
  toolTip,
  toolTipPosition,
  ...props
}) => (
  <div className={createClassNameString(["apti-CL", "apti-FormField", className])} {...props}>
    <div className="apti-FormField--label-container">
      <Text
        className={createClassNameString(["apti-FormField--label", labelClassName])}
        type={TextTypes.label}
      >
        {label}
      </Text>

      {sublabel && (
        <Text className="apti-FormField--label" type={TextTypes.paragraph}>
          {sublabel}
        </Text>
      )}

      {toolTip && <Info position={toolTipPosition}>{toolTip}</Info>}
    </div>

    <div className="apti-FormField--input-container">{children}</div>

    {errorMessage && (
      <Text
        className="apti-FormField--error"
        color={TextColors.red}
        testId={errorTestId}
        type={TextTypes.small}
        {...testLocator(errorTestLocatorId)}
      >
        {errorMessage}
      </Text>
    )}
  </div>
);

FormField.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  errorTestId: PropTypes.string,
  errorTestLocatorId: PropTypes.string,
  label: PropTypes.string.isRequired,
  sublabel: PropTypes.string,
  toolTip: PropTypes.element,
  toolTipPosition: PropTypes.string,
};

FormField.defaultProps = {
  children: <></>,
  className: undefined,
  errorTestId: undefined,
  errorTestLocatorId: undefined,
  label: "",
  labelClassName: undefined,
  sublabel: undefined,
  toolTip: undefined,
  toolTipPosition: "left",
};
